var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.showModal,
        size: "small",
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog__header" },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "default",
          fn: function() {
            return [
              _c("div", { staticClass: "dialog__default" }, [
                _vm.step === 1
                  ? _c(
                      "div",
                      [
                        _c("SaasIcon", {
                          staticClass: "mb-3",
                          attrs: {
                            icon: "scheduler",
                            width: "56",
                            height: "56"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-3" }, [
                          _c("span", { staticClass: "bold fs-5" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__("Planification de rendez-vous")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fs-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$l10n.__(
                                "Informations sur votre compte email"
                              )
                            )
                          )
                        ])
                      ],
                      1
                    )
                  : _c("div", { staticClass: "header-step2" }, [
                      _c("span", { staticClass: "bold fs-5" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Déconnexion compte email")))
                      ])
                    ]),
                _vm._v(" "),
                _vm.step === 1
                  ? _c(
                      "div",
                      { staticClass: "lh-20" },
                      [
                        _vm.connected
                          ? _c(
                              "div",
                              [
                                _c("el-divider", { staticClass: "my-3" }),
                                _vm._v(" "),
                                _c("nylas-scheduler")
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-divider", { staticClass: "my-3" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "account mb-3" }, [
                          _c("p", { staticClass: "bold mb-1" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Compte")))
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.email))])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "status" },
                          [
                            _c("p", { staticClass: "bold mb-1" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Statut")))
                            ]),
                            _vm._v(" "),
                            _c("chip-label", {
                              attrs: {
                                color: _vm.statusChipColor,
                                label: _vm.statusLabel,
                                gap: "medium"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("CompassPlainButton", {
                          staticClass: "mt-2",
                          attrs: {
                            label: _vm.$t.__(
                              "popups.PopupSchedulerSettings.update_status"
                            )
                          },
                          on: { click: _vm.onUpdateStatus }
                        })
                      ],
                      1
                    )
                  : _c("div", [
                      _c("p", { staticClass: "alert alert-danger mb-3" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Vous devez reconnecter votre compte email dans les 30 prochains jours pour garder les liaisons des emails de ce compte avec les fiches sociétés, opportunités et contacts."
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-row" },
                        [
                          _c("el-checkbox", {
                            staticClass: "mr-2",
                            model: {
                              value: _vm.confirmLogout,
                              callback: function($$v) {
                                _vm.confirmLogout = $$v
                              },
                              expression: "confirmLogout"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "pointer",
                              on: {
                                click: function($event) {
                                  _vm.confirmLogout = !_vm.confirmLogout
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__(
                                      "Je confirme avoir pris connaissance du risque de perte de données."
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
              ])
            ]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "dialog__footer" },
                [
                  _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__("common.actions.cancel"),
                      type: "secondary"
                    },
                    on: { click: _vm.onCancelClicked }
                  }),
                  _vm._v(" "),
                  _c("CompassButton", {
                    staticClass: "ml-3",
                    attrs: {
                      label: _vm.labelBtnLogout,
                      type: "primary-destructive",
                      disabled: _vm.logoutDisabled
                    },
                    on: { click: _vm.onLogoutClicked }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [_c("preloader", { attrs: { display: _vm.loader } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }